<template>
  <div class="main">
    <Head type="lipei"/>

    <div class="lipei">
      <div class="title">自助理赔查询</div>
      <img :src="$config.IMG_URL+'/lipei.jpg'" />
    </div>

    <div class="follow">
      <div class="qr row justify-between items-center">
        <img :src="$config.IMG_URL+'/qrcode.png'" />
        <div class="right">
          <p>FOLLOW ME</p>
          <p class="tit">关注中智 关注健康</p>
          <p class="small">中智 | 让健康生活不将就</p>
        </div>
      </div>
    </div>


    <Footer/>
  </div>

</template>

<script>
  import Head from './../components/head'
  import Footer from './../components/footer'
  import Swiper from 'swiper'
  import 'swiper/dist/css/swiper.css';

  export default {
    name: 'Lipei',
    components: {
      Head,
      Footer,
    },
    data () {
      return {

      }
    },
    mounted() {
      document.getElementById('app').scrollTop = 0
    },
  }
</script>

<style scoped lang="less">
  @import "./../assets/common";
  .main{
    position: relative;
    width: 100%;
    min-width: 1364px;
    /*min-width: 800px;*/
    padding-top: 132px;
    max-width: 1920px;
    /*max-width: 1000px;*/
    margin: 0 auto;
    overflow: hidden;
  }


  .banner{
    width: 100%;
    height: 816px;
    .swiper-slide{
      position: relative;
      overflow: hidden;
      img{
        height: 816px;
        position: relative;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }
  }


  .lipei{
    width: 100%;
    height: 570px;
    min-width: 1364px;
    position: relative;
    overflow: hidden;
    margin-top: 80px;
    text-align: center;
    .title{
      width: 100%;
      text-align: center;
      font-size: 36px;
      height: 60px;
      line-height: 60px;
    }
    img{
      width: 1364px;
      margin: 77px auto 156px auto;
    }
  }

  .follow {
    width: 100%;
    height: 320px;
    min-width: 1364px;
    position: relative;
    overflow: hidden;
    background: #fbfbfb;
    .qr{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      height: 120px;
      width: 454px;
      img{
        width: 120px;
        height: 120px;
      }
      p{
        font-size: 20px;
        line-height: 30px;
        &.tit{
          font-size: 36px;
          font-weight: bold;
          line-height: 60px;
        }
        &.small{
          font-size: 18px;
        }
      }
    }
  }

  

  .content{
    overflow: hidden;
  }
</style>

<style lang="less">
  @import "./../assets/common";

  .banner_page{
    bottom: 20px !important;
    .swiper-pagination-bullet{
      background: #ffffff;
      opacity: 1;
      margin: 0 8px !important;
    }
    .swiper-pagination-bullet-active{
      background: @blue;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/lipei.vue